<template>
    <div class="cart_container" :class="{ 'cart_open': !buttonCartIsVisible(), 'cart_close': buttonCartIsVisible() }">
        <div class="overlay" v-if="cartVisible" @click="toggleCartVisibility()">
            <DefaultButton :text="getString('continuar_comprando')" outlined="true" :layoutGom="true"></DefaultButton>
        </div>
        <div class="minimize_cart" v-if="!buttonCartIsVisible() && cart && cart.length !== 0" @click="minimizeCart()">
            <img :src="minus_white">
        </div>
        <ShowCart v-if="!isCartEmpty && buttonCartIsVisible()" class="gom-layout"
            @toggleCartVisibility="toggleCartVisibility()"></ShowCart>
        <div class="empty_cart" v-if="cart.length === 0 && false">
            <img :src="shopping_cart_white">
            <span v-text="getString('carrinho_vazio')"></span>
        </div>
        <transition name="cart-itens-container-landscape">
            <div class="cart-itens-container" v-if="cartVisible">
                <TransitionGroup name="list-cart" tag="div">
                    <div class="cart_item_container" v-for="(product, key) in cart" :key="product.index">
                        <QuantityControl v-if="!product.productScale" :quantity="product.quantity" :layoutGom="true"
                            @circleBtnRemove="decreaseQtty(key)" @circleBtnAdd="increaseQtty(key)">
                        </QuantityControl>
                        <div v-else class="prod_quantity">
                            <span v-text="product.quantity + ' Kg'"></span>
                        </div>
                        <div class="product_item">
                            <span class="prod_name" :class="{ 'unavaiable': getLimits(product.productCode) }">
                                {{ getProductLanguage(product, 'productName') }}
                                <span v-if="unavailableProducts[product.productCode]"
                                    v-text="buildText(product.productCode)"></span>
                            </span>
                            <span
                                v-if="product.observations && product.observations.length === 0 && product.productCombo && product.productCombo.length === 0"
                                class="prod_description"
                                v-text="getProductLanguage(product, 'productDescription')"></span>
                            <div v-else class="observations">
                                <!-- Exibe as observações no carrinho -->
                                <div class='product-observations' v-for="(observation, key) in product.observations"
                                    :key="key">
                                    <li :class="{ 'unavaiable': getLimits(observation.obsProductCode) }">{{
                                        getProductLanguage(observation, 'obsName') }}</li>
                                </div>
                                <!-- Exibe no carrinho os itens do combo que foram escolhidos -->
                                <div class="sub-item" v-for="(comboItem, key2) in product.productCombo" :key="key2">
                                    <span :class="{ 'unavaiable': getLimits(comboItem.subItemCode) }">
                                        {{ getProductLanguage(comboItem, 'subItemName') }}
                                        <span v-if="unavailableProducts[comboItem.subItemCode]"
                                            v-text="buildText(comboItem.subItemCode)"></span>
                                    </span>
                                    <div class="sub-item-obs" v-for="(comboItemObs, key3) in comboItem.observations"
                                        :key="key3">
                                        <li :class="{ 'unavaiable': getLimits(comboItemObs.subItemObsProductCode) }"> {{
                                            getProductLanguage(comboItemObs, 'subItemObsName') }} </li>
                                    </div>
                                    <div class="c-combo-options"
                                        v-for="(choosen, key4) in getProductsComboCombo(comboItem.choosen)" :key="key4">
                                        <span :class="{ 'unavaiable': getLimits(choosen.subItemCode) }">
                                            {{ getProductLanguage(choosen, 'subItemName') }}
                                            <span v-if="unavailableProducts[choosen.subItemCode]"
                                                v-text="buildText(choosen.subItemCode)"></span>
                                        </span>
                                        <div class="c-combo-obs" v-for="(ccObservations, key5) in choosen.observations"
                                            :key="key5">
                                            <li
                                                :class="{ 'unavaiable': getLimits(ccObservations.subItemObsProductCode) }">
                                                {{ getProductLanguage(ccObservations, 'subItemObsName') }}</li>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <span class="item_price">{{ calculateItemPrice(product) }}</span>
                        <div class="cart-items-buttons">
                            <CircleButton class="edit_button" v-if="!product.productScale" :icon="edit_white"
                                :disabled="product.insertedByEan13 || product.isertedByBarCode" :layoutGom="true"
                                :text="getString('editar')" :big="iconesGrandes" @circleBtnClick="edit(product, key)">
                            </CircleButton>
                            <CircleButton v-if="product.productScale" :icon="delete_white" :big="iconesGrandes"
                                :layoutGom="true" @circleBtnClick="deleteProduct(key)"></CircleButton>
                        </div>
                    </div>
                </TransitionGroup>
            </div>
        </transition>
        <div>
            <div class="total_price">
                <span class="price_text">{{ getString('total_caps') }}</span>
                <span class="price_number">{{ calculateTotalPrice() }}</span>
            </div>
            <div class="footer_buttons">
                <DefaultButton :text="getString('cancelar')" :outlined="true" :layoutGom="true"
                    @defaultBtnClick="clearCart"></DefaultButton>
                <DefaultButton :text="wait ? getString('aguarde') : getString('confirmar_pedido')"
                    :disabled="cart.length === 0 || wait" @defaultBtnClick="navigateToCheckout"></DefaultButton>
            </div>
        </div>
    </div>
</template>

<script>
import Util from '@/assets/libs/util'
import DefaultButton from '@/components/DefaultButton'
import CircleButton from '@/components/CircleButton'
import QuantityControl from '@/components/QuantityControl'
import LocaleController from '@/assets/controllers/LocaleController'
import CartController from '@/assets/controllers/CartController'
import eventModule from '@/assets/libs/eventModule'
import ShowCart from '../components/ShowCart.vue'

export default {
    name: 'CartGom',
    components: {
        DefaultButton,
        CircleButton,
        QuantityControl,
        ShowCart
    },
    data () {
        return {
            cartVisible: false,
            showButtonCart: false,
            isCartEmpty: CartController.getCart().length === 0,
            cart: [],
            shopping_cart_white: require('../../static/icons/shopping_cart_white.svg'),
            edit_white: require('../../static/icons/edit_white.svg'),
            delete_white: require('../../static/icons/delete_white.svg'),
            minus_white: require('../../static/icons/minus_white.svg'),
            iconesGrandes: Util.getLocalConfigs('iconesGrandes'),
            wait: false,
            unavailableProducts: CartController.getUnavailableProducts()
            // arrow_right_white: require('../../static/icons/close_white.svg')
        }
    },
    created () {
        this.cart = CartController.getCart()
        eventModule.$on('openCart', this.toggleCartVisibility)
        eventModule.$on('toggleWaitStatus', this.toggleWaitStatus)
    },
    beforeDestroy () {
        eventModule.$off('openCart', this.toggleCartVisibility)
        eventModule.$off('toggleWaitStatus', this.toggleWaitStatus)
    },
    methods: {
        minimizeCart: function () {
            eventModule.$emit('refreshProductsCounter')
            this.cartVisible = false
        },
        getString: function (key) {
            return LocaleController.getString(key)
        },
        calculateItemPrice: function (product) {
            return CartController.calculateItemPrice(product)
        },
        calculateTotalPrice: function () {
            return CartController.calculateTotalPrice(false, false)
        },
        decreaseQtty: function (key) {
            CartController.decreaseQtty(key, this)
            this.isCartEmpty = CartController.getCart().length === 0
            this.$forceUpdate()
        },
        increaseQtty: function (key) {
            CartController.increaseQtty(key)
            this.$forceUpdate()
        },
        navigateToCheckout: function () {
            CartController.navigateToCheckout(this.$router)
        },
        deleteProduct: function (key) {
            CartController.deleteProduct(key, this)
            this.isCartEmpty = CartController.getCart().length === 0
            this.$forceUpdate()
        },
        clearCart: function () {
            if (CartController.isCartEmpty()) {
                this.$router.push('/')
            } else {
                CartController.clearCart(this, '/')
            }
        },
        edit: function (product, key) {
            eventModule.$emit('closeProductItem')
            setTimeout(() => {
                eventModule.$emit('openProductItem', { product: product, key: key })
            }, 200)
        },
        getProductLanguage: function (product, index) {
            return LocaleController.getIndexLanguages(product, index)
        },
        getProductsComboCombo: function (choosen) {
            let combos = []
            if (choosen) {
                Object.keys(choosen).forEach((e) => {
                    choosen[e].forEach((c) => {
                        combos.push(c)
                    })
                })
            }
            return combos
        },
        toggleCartVisibility: function (status = null) {
            this.isCartEmpty = CartController.getCart().length === 0
            if (status) {
                this.cartVisible = status
                setTimeout(() => {
                    let itemCart = document.querySelectorAll('.cart_item_container')
                    if (itemCart && itemCart.length > 0) {
                        itemCart = itemCart[itemCart.length - 1]
                        itemCart.scrollIntoView({ behavior: 'smooth' })
                    }
                }, 300)
            } else {
                this.cartVisible = !this.cartVisible
            }
        },
        isGomLayout: function () {
            return Util.getLocalConfigs('utiliza_layout_gom')
        },
        buttonCartIsVisible: function () {
            return !this.cartVisible
        },
        toggleWaitStatus: function (status) {
            this.wait = status
        },
        getLimits: function (productCode) {
            if (this.unavailableProducts && this.unavailableProducts[productCode]) {
                return this.unavailableProducts[productCode].quantity > this.unavailableProducts[productCode].quantityAvailable
            }
            return false
        },
        buildText: function (productCode) {
            if (this.productsUnavailable && this.productsUnavailable[productCode]) {
                return `${this.productsUnavailable[productCode].quantity} ${this.getString('de')} ${this.productsUnavailable[productCode].quantityAvailable}`
            }
            return ''
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang='less'>
@import (reference) url("../assets/common.less");

.cart_container {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    font-size: 2rem;
    background: @cart-color;
    color: @cart-font-color;
    border-top: solid 3px;

    .cart-itens-container {
        max-height: 405px;
        overflow: auto;
        overflow-x: hidden;
    }

    .overlay {
        display: none;
    }

    .minimize_cart {
        width: 100px;
        height: 50px;
        background-color: @primary-color;
        display: flex;
        align-items: center;
        justify-content: center;
        position: absolute;
        margin-top: -50px;
        right: 0;

        img {
            width: 48px;
            height: 48px;
        }
    }

    &.cart_open {
        max-height: 560px;
        transition: max-height 0.4s ease-in;
    }

    &.cart_close {
        max-height: 180px;
        transition: max-height 0.3s ease-out;
    }

}

.empty_cart {
    padding-top: 3rem;
    display: flex;
    flex-direction: column;
    align-items: center;

    img {
        width: 200px;
        height: 150px;
        -webkit-filter: drop-shadow(3px 3px 3px rgba(0, 0, 0, 0.2));
        filter: drop-shadow(3px 3px 3px rgba(0, 0, 0, 0.2));
    }

    span {
        padding-top: 15px;
        font-size: 3rem;
        color: @cart-font-color;
    }

    button {
        margin: 20px;
    }
}

.cart_item_container {
    display: grid;
    position: relative;
    padding: 30px;
    grid-template-columns: 200px 50% auto max-content;

    .cart-items-buttons {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
    }

    .prod_quantity {
        font-weight: bold;
        text-align: center;
    }
}

.item_quantity {
    font-weight: bold;
    margin: auto;
    display: block;
    text-align: center;
}

.prod_name {
    font-weight: bold;
    padding-bottom: 10px;
}

.prod_description {
    font-size: 22px;
}

.item_price {
    font-size: 25px;
    text-align: right;
    padding: 10px 10px;
}

.total_price {
    display: flex;
    justify-content: flex-end;
    align-items: flex-end;
    padding-right: 30px;
    padding-top: 15px;
    padding-bottom: 15px;
    margin-right: 15px;
}

.price_text {
    font-size: 25px;
    padding-right: 10px;
}

.price_number {
    font-size: 30px;
    font-weight: bold;
}

.product_item {
    span {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
    }

    .unavaiable {
        color: red;
    }

    .observations {
        font-size: 22px;
        display: flex;
        flex-wrap: wrap;
        padding-left: 20px;

        .product-observations {
            width: 100%;
        }

        span {
            display: flex;
            margin: 0 5px 5px 0;
            font-weight: normal;
            flex-direction: row;
            flex-wrap: wrap;
            padding: 5px 8px;
            border-radius: 10px;
        }

        .sub-item {
            width: 100%;

            span {
                font-weight: bold;
                font-size: 25px;
            }

            .sub-item-obs {
                padding-left: 20px;
                width: 100%;

                li {
                    font-weight: normal;
                    list-style: square;
                }
            }
        }

        .c-combo-options {
            padding-left: 20px;

            li {
                padding-left: 20px;
            }
        }
    }
}

.footer_buttons {
    display: flex;
    justify-content: space-around;
    padding-bottom: 15px;

    .button-default {
        width: calc(50% - 30px);
    }
}

@media (min-width: 699px) and (max-width: 1025px) {

    //@tablet
    .cart_container {

        // height: 400px;
        .cart-itens-container {
            max-height: 300px;
        }

        .minimize_cart {
            width: 50px;
            height: 25px;
            margin-top: -25px;

            img {
                width: 24px;
                height: 24px;
            }
        }

        &.cart_open {
            max-height: 400px;
            transition: max-height 0.4s ease-in;
        }

        &.cart_close {
            max-height: 155px;
            transition: max-height 0.3s ease-out;
        }
    }

    .empty_cart {
        padding-top: 40px;

        img {
            width: 160px;
            height: 160px;
        }

        span {
            font-size: 35px;
        }

        button {
            margin: 30px;
        }
    }

    .cart_item_container {
        padding: 10px;
        grid-template-columns: 150px 42% auto auto;

        .cart-items-buttons {
            max-width: 100px;
        }

        .prod_quantity {
            font-size: 25px;
        }
    }

    .item_price {
        padding: 5px 10px;
        font-size: 25px;
    }

    .total_price {
        padding-right: 0;
        margin-right: 20px;
    }

    .price_text {
        font-size: 20px;
        padding-right: 10px;
        padding-bottom: 1px;
    }

    .price_number {
        font-size: 26px;
    }

    .product_item {
        padding-left: 20px;

        .prod_name {
            font-size: 22px;
        }

        .prod_description {
            font-size: 16px;
        }

        .observations {
            font-size: 16px;

            .sub-item {
                span {
                    font-size: 18px;
                }
            }
        }
    }
}

@media (max-width: 698px) {

    // Gertec SK210
    .cart_container {

        // height: 280px;
        .cart-itens-container {
            max-height: 200px;
        }

        .minimize_cart {
            width: 50px;
            height: 25px;
            margin-top: -25px;

            img {
                width: 24px;
                height: 24px;
            }
        }

        &.cart_open {
            max-height: 280px;
            transition: max-height 0.4s ease-in;
        }

        &.cart_close {
            max-height: 105px;
            transition: max-height 0.3s ease-out;
        }
    }

    .empty_cart {
        padding-top: 15px;

        img {
            width: 120px;
            height: 120px;
        }

        span {
            font-size: 26px;
        }
    }

    .cart_item_container {
        padding: 5px;
        grid-template-columns: 115px 42% auto auto;

        .cart-items-buttons {
            max-width: 80px;
        }

        .prod_quantity {
            font-size: 18px;
        }
    }

    .item_price {
        padding: 5px 5px;
        font-size: 16px;
    }

    .total_price {
        padding-right: 0;
        margin-right: 20px;
        padding-top: 10px;
        padding-bottom: 10px;
    }

    .price_text {
        font-size: 16px;
        padding-right: 10px;
        padding-bottom: 1px;
    }

    .price_number {
        font-size: 18px;
    }

    .product_item {
        padding-left: 10px;

        .prod_name {
            padding-top: 5px;
            font-size: 16px;
        }

        .prod_description {
            padding-left: 10px;
            font-size: 15px;
        }

        .observations {
            font-size: 15px;
            padding-left: 10px;

            .sub-item {
                span {
                    font-size: 14px;
                    margin: 0 3px 3px 0;
                }
            }
        }
    }
}

.upper-in-out-enter-active {
    bottom: 0;
    animation: upper-in-out 0.6s;
}

.upper-in-out-leave-active {
    bottom: 0;
    animation: upper-in-out 0.6s reverse;
}

@keyframes upper-in-out {
    0% {
        transform: translateY(200px);
    }

    100% {
        transform: translateY(20px);
    }
}

@media (orientation: landscape) {
    .cart_container {
        z-index: 3;

        .cart-itens-container {
            z-index: 3;
            position: absolute;
            top: 90px;
            bottom: 82px;
            right: 0;
            max-height: unset;
            width: 55vw;
            background-color: @cart-color;
            padding: 10px 0;
        }

        .overlay {
            position: fixed;
            top: 0;
            left: 0;
            right: 0;
            bottom: 110px;
            background-color: rgba(0, 0, 0, 0.6);
            z-index: 2;
            display: block;

            .button-default {
                z-index: 10;
                position: absolute;
                top: 50%;
                left: 15%;
            }
        }

        .minimize_cart {
            display: none;
            z-index: 10;
            width: 50px;
            height: 25px;
            margin-top: -25px;

            img {
                width: 24px;
                height: 24px;
            }
        }
        >div:last-child {
            z-index: 3;
            display: flex;
            flex-direction: row-reverse;
            justify-content: space-between;
            align-items: center;
            padding: 10px;
        }
    }

    .cart_item_container {
        z-index: 3;
        width: 100%;
        padding: 10px;
        grid-template-columns: auto 30% auto auto;
        border-bottom: solid 1px rgba(0, 0, 0, 0.1);

        .cart-items-buttons {
            max-width: 100px;
        }
    }

    .item_price {
        padding: 5px 10px;
        font-size: 24px;
    }

    .total_price {
        padding-right: 30px;
        margin-right: 0;
        padding-top: 0;
        padding-bottom: 0;
        order: 2;
    }

    .footer_buttons {
        display: flex;
        justify-content: space-around;
        align-items: center;
        width: 50%;
        padding-bottom: 0;

        .button-default {
            max-width: 250px;
        }
    }

    .price_text {
        font-size: 20px;
        padding-right: 10px;
        padding-bottom: 1px;
    }

    .price_number {
        font-size: 25px;
    }

    .product_item {
        padding-left: 5px;

        .prod_name {
            font-size: 20px;
        }

        .prod_description {
            font-size: 16px;
        }

        .observations {
            font-size: 16px;

            .sub-item {
                span {
                    font-size: 16px;
                }
            }
        }
    }

    .cart-itens-container-landscape-enter-active,
    .cart-itens-container-landscape-leave-active {
        transition: transform 0.35s ease;
    }

    .cart-itens-container-landscape-enter {
        transform: translateX(100%);
    }

    .cart-itens-container-landscape-enter-to {
        transform: translateX(0);
    }

    .cart-itens-container-landscape-leave {
        transform: translateX(0);
    }

    .cart-itens-container-landscape-leave-to {
        transform: translateX(100%);
    }
}
</style>



// WEBPACK FOOTER //
// src/components/CartGom.vue